// Copyright (C) 2021 Intel Corporation
//
// SPDX-License-Identifier: MIT

// The sparkles that mark AI-made content across the grades panel: one large four-pointed
// star and two small ones, drawn in the current text colour like any antd icon.

import React from 'react';
import Icon from '@ant-design/icons';

function SparklesSvg(): JSX.Element {
    return (
        <svg width='1em' height='1em' viewBox='0 0 24 24' fill='currentColor' aria-hidden='true'>
            <path d='M9.5 5.5c.55 4.55 3.45 7.45 8 8-4.55.55-7.45 3.45-8 8-.55-4.55-3.45-7.45-8-8 4.55-.55 7.45-3.45 8-8Z' />
            <path d='M18.5 1.5c.27 1.93 1.07 2.73 3 3-1.93.27-2.73 1.07-3 3-.27-1.93-1.07-2.73-3-3 1.93-.27 2.73-1.07 3-3Z' />
            <path d='M19.75 16.25c.19 1.23.77 1.81 2 2-1.23.19-1.81.77-2 2-.19-1.23-.77-1.81-2-2 1.23-.19 1.81-.77 2-2Z' />
        </svg>
    );
}

function AiSparklesIcon(props: { className?: string }): JSX.Element {
    return <Icon component={SparklesSvg} {...props} />;
}

export default React.memo(AiSparklesIcon);
